export const domain = 'https://adamapi.amplius.tech';
//export const domain = 'http://localhost:8000';